(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('EditarVigenciaDialogController', EditarVigenciaDialogController);

    EditarVigenciaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSProyecto', 'AlertService'];

    function EditarVigenciaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSProyecto, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSProyecto = result;
        });

        vm.clear = clear;
        vm.save = save;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSProyecto.updateVigencia(
        		vm.sSProyecto
            , onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        
        vm.datePickerOpenStatus.finVigencia = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al editar la vigencia del proyecto.");
        }

    }
})();
